function arraySwap(arr: any[], a: number, b: number) {
  return arr.map((current, index) => {
    if (index === a) return arr[b];
    if (index === b) return arr[a];
    return current;
  });
}

export default arraySwap;
